/**
 * Global axios interceptor for JWT authentication.
 * Call setupAxiosInterceptor() once at app startup.
 * All subsequent axios calls to /api/* will automatically include the JWT token.
 */
import axios from 'axios';

const TOKEN_KEY = 'impulse_token';

let _installed = false;

export function setupAxiosInterceptor() {
  if (_installed) return;
  _installed = true;

  // Request interceptor: inject JWT token
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    const url = config.url || '';
    const isApiCall = url.startsWith('/api') || url.includes('/api/');

    if (token && isApiCall) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  });

  // Response interceptor: auto-logout ONLY on genuine JWT failures
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        const data = error.response.data;
        const JWT_ERRORS = ['Token expiré', 'Token invalide'];
        if (data && JWT_ERRORS.includes(data.error)) {
          console.warn('[AUTH-AXIOS] JWT hard 401 → auto-logout:', error.config?.url, data.error);
          localStorage.removeItem(TOKEN_KEY);
          localStorage.removeItem('impulse_auth');
          window.location.reload();
        } else {
          console.log('[AUTH-AXIOS] Non-JWT 401 (ignored):', error.config?.url, data?.error);
        }
      }
      return Promise.reject(error);
    }
  );
}
